export default {
  title: "Connecties",
  view: {
    noItems: {
      title: "Nog geen connecties",
      text: "Klik om een connectie toe te voegen"
    }
  },
  input: {
    module: "Module",
    entity: "Entiteit",
    type: "Type"
  }
}
